import React, { useCallback, useEffect } from 'react';
import { Form, Input } from 'antd';

const typeToComponent = {
  'text-area': Input.TextArea,
  input: Input
};

export const FormInput = (props) => {
  const {
    name,
    label,
    placeholder,
    required = false,
    disabled,
    componentType = 'input',
    formData,
    formatter,
    hidden
  } = props;

  const Component = typeToComponent[componentType];

  const formValue = formData?.[name];

  const setFormValue = useCallback(
    (key, value) => {
      formData?.setFieldValue(key, value);
    },
    [formData]
  );

  useEffect(() => {
    if (formatter) {
      formatter(formValue, setFormValue);
    }
  }, [formatter, formValue, setFormValue]);

  return (
    <Form.Item
      name={name}
      label={label}
      rules={required ? [{ required: true, message: 'Required field' }] : []}
      hidden={hidden}
      preserve
    >
      <Component placeholder={placeholder} disabled={disabled} />
    </Form.Item>
  );
};
